<template>
  <el-drawer
    :title="
      params.drawerType === 'edit' || params.drawerType === 'childEdit' ? '编辑字段' : '创建字段'
    "
    :visible.sync="drawerVisible"
    direction="rtl"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    @closed="onDrawerClosed"
  >
    <drawer-wrapper with-footer class="analyze-drawer">
      <el-form
        :model="analyzeForm"
        :rules="analyzeRules"
        ref="analyzeForm"
        label-width="120px"
        :inline-message="true"
        class="analyze-form"
        v-loading="formLoading"
      >
        <el-alert
          class="analyze-alert"
          v-if="params.parentName"
          :title="`父字段：${params.parentName}`"
          type="warning"
          :closable="false"
        >
        </el-alert>
        <el-form-item class="form-tip-top" prop="fieldName" label="字段名称：">
          <el-autocomplete
            class="analyze-form-input"
            v-model="analyzeForm.fieldName"
            :fetch-suggestions="querySearch"
            placeholder="请输入字段名称"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <p class="form-tip">
            实际数据字段名称
          </p>
        </el-form-item>
        <el-form-item
          class="analyze-drawer-description form-tip-top"
          prop="fieldType"
          label="类型："
        >
          <el-select
            class="analyze-form-input"
            v-model="analyzeForm.fieldType"
            placeholder="请选择类型"
            :disabled="
              analyzeForm.analysisConfigDtoList && analyzeForm.analysisConfigDtoList.length > 0
            "
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <p class="form-tip">
            数据类型
          </p>
        </el-form-item>

        <div v-if="analyzeForm.fieldType !== 'json'">
          <el-form-item class="analyze-form-advance">
            <el-button
              class="analyze-form-advance-btn"
              type="text"
              @click="isAdvanced = !isAdvanced"
              >{{ !isAdvanced ? '高级选项' : '收起' }}</el-button
            >
          </el-form-item>
          <transition name="fade-advance">
            <div v-if="isAdvanced">
              <el-form-item class="form-tip-top" prop="alias" label="别名">
                <el-input
                  class="analyze-form-input"
                  type="input"
                  v-model="analyzeForm.alias"
                  placeholder="请输入别名"
                >
                </el-input>
              </el-form-item>
              <el-form-item>
                <p class="form-tip">
                  可以为字段名称指定一个别名
                </p>
              </el-form-item>
              <el-form-item class="form-tip-top" prop="openStatistics" label="开启统计">
                <el-switch v-model="analyzeForm.openStatistics" active-color="#13ce66"> </el-switch>
              </el-form-item>
              <el-form-item>
                <p class="form-tip">
                  选择开启统计，搜索时中文将按照全部匹配搜索
                </p>
              </el-form-item>
            </div>
          </transition>
        </div>
      </el-form>
      <template #footer>
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onSubmit" :loading="loading">
          {{ loading ? `${params.submitLabel}中 ...` : params.submitLabel }}
        </el-button>
      </template>
    </drawer-wrapper>
  </el-drawer>
</template>

<script>
import DrawerWrapper from '../../../components/DrawerWrapper/Index';
import AnalyzeConfig from '../../../models/AnalyzeConfig';
import Validator from '../../../utils/Validator';

export default {
  name: 'analyzeConfigCreatorAndEditor',

  components: {
    DrawerWrapper
  },

  data() {
    const validatorStandardStr = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNoSpace())
        .register(validator.isStandardStr())
        .validate();
    };

    const validatorLength = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator.register(validator.lenRange(50)).validate();
    };

    const validatorNotEqual = (rule, value, cb) => {
      const validator = new Validator(rule, value, cb);
      validator
        .register(validator.isNotEqual(this.analyzeForm.fieldName, '别名和字段名称不能相同'))
        .validate();
    };

    return {
      params: {
        drawerType: 'create',
        submitLabel: '提交',
        index: null,
        childIndex: null,
        parentName: ''
      },
      drawerVisible: false,
      analyzeForm: {
        fieldName: '',
        fieldType: '',
        alias: '',
        analysisConfigDtoList: [],
        openStatistics: true
      },
      analyzeRules: {
        fieldName: [
          { required: true, message: '请输入字段名称', trigger: ['blur', 'change'] },
          { validator: validatorStandardStr, trigger: ['blur', 'change'] },
          { validator: validatorLength, trigger: 'blur' }
        ],
        fieldType: { required: true, message: '请选择字段类型', trigger: 'change' },
        alias: [
          { validator: validatorNotEqual, trigger: 'blur' },
          { validator: validatorLength, trigger: 'blur' }
        ]
      },
      isAdvanced: false,
      formLoading: false,
      loading: false,
      analyzeKeys: []
    };
  },

  computed: {
    typeOptions() {
      if (this.params.drawerType === 'create' || this.params.drawerType === 'edit') {
        return [
          {
            label: 'text',
            value: 'text'
          },
          {
            label: 'long',
            value: 'long'
          },
          {
            label: 'double',
            value: 'double'
          },
          // @ZY@2019/11/16: 添加 integer
          {
            label: 'integer',
            value: 'integer'
          },
          {
            label: 'json',
            value: 'json'
          }
        ];
      } else {
        return [
          {
            label: 'text',
            value: 'text'
          },
          {
            label: 'long',
            value: 'long'
          },
          {
            label: 'double',
            value: 'double'
          },
          {
            label: 'integer',
            value: 'integer'
          }
        ];
      }
    }
  },

  created() {
    this.analyzeKeys =
      JSON.parse(sessionStorage.getItem('analyzeKeys')).column_keys &&
      JSON.parse(sessionStorage.getItem('analyzeKeys')).column_keys.length > 0
        ? JSON.parse(sessionStorage.getItem('analyzeKeys')).column_keys.map(key => ({
            value: key
          }))
        : [];
  },

  methods: {
    async open({ type, parentData, data, index, childIndex }) {
      this.params.drawerType = type;
      this.params.index = index;
      this.params.childIndex = childIndex;
      await this.$nextTick();
      this.drawerVisible = true;
      if (type === 'create') {
        return;
      }

      if (type === 'childCreate') {
        this.params.parentName = data.fieldName;
        return;
      }

      if (type === 'childEdit') {
        this.params.parentName = parentData.fieldName;
      }

      this.analyzeForm = new AnalyzeConfig({
        fieldName: data.fieldName,
        fieldType: data.fieldType,
        alias: data.alias,
        openStatistics: data.openStatistics,
        analysisConfigDtoList: data.analysisConfigDtoList,
        logId: JSON.parse(sessionStorage.getItem('logData')).id
      });
    },
    close() {
      this.drawerVisible = false;
    },
    querySearch(queryString, cb) {
      const analyzeKeys = this.analyzeKeys;
      var results = queryString ? analyzeKeys.filter(this.createFilter(queryString)) : analyzeKeys;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    onDrawerClosed() {
      this.params = {
        drawerType: 'create',
        submitLabel: '提交',
        index: null,
        parentName: ''
      };

      this.analyzeForm = {
        fieldName: '',
        fieldType: '',
        alias: '',
        openStatistics: true,
        analysisConfigDtoList: []
      };
      this.$refs.analyzeForm.resetFields();
      this.isAdvanced = false;
    },
    onCancel() {
      this.drawerVisible = false;
    },
    async onSubmit() {
      try {
        await this.$refs.analyzeForm.validate();
      } catch (e) {
        return;
      }

      this.loading = true;

      await this.$emit('submit', {
        data: new AnalyzeConfig({
          fieldName: this.analyzeForm.fieldName,
          fieldType: this.analyzeForm.fieldType,
          alias: this.analyzeForm.alias,
          openStatistics: this.analyzeForm.openStatistics,
          analysisConfigDtoList: this.analyzeForm.analysisConfigDtoList,
          logId: JSON.parse(sessionStorage.getItem('logData')).id
        }),
        index: this.params.index,
        childIndex: this.params.childIndex,
        type: this.params.drawerType
      });

      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.analyze {
  &-form {
    &-input {
      width: 100%;
    }

    &-advance {
      &-btn {
        font-size: 14px !important;
      }
    }
  }

  &-alert {
    margin-bottom: 20px;
  }
}

.fade-advance-enter-active,
.fade-advance-leave-active {
  transition: all 0.5s;
}

.fade-advance-enter,
.fade-advance-leave-to {
  opacity: 0;
}
</style>
